var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassportPhase4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 782 262.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .passport-disable-rect{\n        fill: #edeef0; \n      }\n      .passport-disable-rect:hover {\n        pointer-events: none;\n        fill: #edeef0;   \n      }\n      .cls-1-Passport-p4 {\n        stroke-width: .05px;\n      }\n\n      .cls-1-Passport-p4, .cls-2-Passport-p4 {\n        fill: #fcce14;\n      }\n\n      .cls-1-Passport-p4, .cls-2-Passport-p4, .cls-3-Passport-p4, .cls-4-Passport-p4 {\n        stroke: #fcce14;\n      }\n\n      .cls-5-Passport-p4, .cls-6-Passport-p4 {\n        stroke-width: 0px;\n      }\n\n      .cls-6-Passport-p4, .cls-3-Passport-p4 {\n        fill: #fff;\n      }\n\n      .cls-3-Passport-p4 {\n        stroke-width: 2px;\n      }\n\n      .cls-4-Passport-p4 {\n        fill: none;\n      }\n\n      .cls-7-Passport-p4 {\n        fill: url(#passport-linear-gradient1-p4);\n        stroke: #1071e5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "passport-linear-gradient1-p4",
    x1: 14670.93,
    y1: -1279.31,
    x2: 14670.93,
    y2: -1377.99,
    gradientTransform: "translate(-14061.49 -1116.29) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cfe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-Passport-p4",
    d: "M1.01,7C1.01,3.69,3.7,1,7.01,1h330.24c3.31,0,6,2.69,6,6v86.7c0,3.31-2.69,6-6,6H7c-3.31,0-6-2.69-6-6V7Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m",
    className: "cls-5-Passport-p4",
    d: "M48.51,30.58c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM41.92,29.83c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM41.92,37.64c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    className: "cls-5-Passport-p4",
    d: "M55.57,23.79v-2.04h2.17v2.04h-2.17ZM55.57,39.47v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    className: "cls-5-Passport-p4",
    d: "M60.39,33.91v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    className: "cls-5-Passport-p4",
    d: "M76.96,37.03c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM70.64,35.87c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    className: "cls-5-Passport-p4",
    d: "M88.91,26.3c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-2",
    "data-name": "q",
    className: "cls-5-Passport-p4",
    d: "M102.49,26.3c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    className: "cls-5-Passport-p4",
    d: "M113.83,39.74c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p-2",
    "data-name": "p",
    className: "cls-5-Passport-p4",
    d: "M131.28,37.03c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM124.96,35.87c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "cls-5-Passport-p4",
    d: "M136.92,39.47v-17.72h2.17v17.72h-2.17"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "cls-5-Passport-p4",
    d: "M161.83,27.32c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-5-Passport-p4",
    d: "M171.82,26.3c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM171.75,38.12c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-3",
    "data-name": "q",
    className: "cls-5-Passport-p4",
    d: "M186.55,26.3c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    className: "cls-5-Passport-p4",
    d: "M196.19,36.28c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "cls-5-Passport-p4",
    d: "M206.72,28.41c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-2",
    "data-name": "u",
    className: "cls-5-Passport-p4",
    d: "M213.85,26.3c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM213.78,38.12c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s-2",
    "data-name": "s",
    className: "cls-5-Passport-p4",
    d: "M222.27,39.47v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s-3",
    "data-name": "s",
    className: "cls-5-Passport-p4",
    d: "M227.63,39.47v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "cls-5-Passport-p4",
    d: "M238.16,26.3c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM241.69,31.8c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-5-Passport-p4",
    d: "M250.72,26.3c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM251.33,27.93c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "z",
    className: "cls-5-Passport-p4",
    d: "M277.88,26.64c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-2",
    "data-name": "x",
    className: "cls-5-Passport-p4",
    d: "M288.4,26.3c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM291.93,31.8c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s-4",
    "data-name": "s",
    className: "cls-5-Passport-p4",
    d: "M296.82,39.47v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-5-Passport-p4",
    d: "M307.42,23.58c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "B",
    className: "cls-5-Passport-p4",
    d: "M54.11,68.81l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM51.53,62.08l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "cls-5-Passport-p4",
    d: "M65.65,59.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-2",
    "data-name": "C",
    className: "cls-5-Passport-p4",
    d: "M77.87,59.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-3",
    "data-name": "x",
    className: "cls-5-Passport-p4",
    d: "M87.72,55.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM91.25,61.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-3",
    "data-name": "C",
    className: "cls-5-Passport-p4",
    d: "M103.68,59.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-4",
    "data-name": "C",
    className: "cls-5-Passport-p4",
    d: "M115.9,59.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "cls-5-Passport-p4",
    d: "M133.21,57.33c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-4",
    "data-name": "x",
    className: "cls-5-Passport-p4",
    d: "M146.05,55.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM149.58,61.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-4",
    "data-name": "q",
    className: "cls-5-Passport-p4",
    d: "M160.78,55.63c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-2",
    "data-name": "v",
    className: "cls-5-Passport-p4",
    d: "M170.42,65.62c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-5",
    "data-name": "C",
    className: "cls-5-Passport-p4",
    d: "M182.37,59.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "cls-5-Passport-p4",
    d: "M198.74,57.33c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-3",
    "data-name": "u",
    className: "cls-5-Passport-p4",
    d: "M211.23,55.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM211.17,67.45c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-2",
    "data-name": "D",
    className: "cls-5-Passport-p4",
    d: "M232.28,57.33c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-5-Passport-p4",
    d: "M246.13,55.63c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM245.59,67.45c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s-5",
    "data-name": "s",
    className: "cls-5-Passport-p4",
    d: "M253.54,68.81v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-5",
    "data-name": "x",
    className: "cls-5-Passport-p4",
    d: "M264.06,55.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM267.59,61.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-3",
    "data-name": "v",
    className: "cls-5-Passport-p4",
    d: "M274.86,65.62c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-6",
    "data-name": "x",
    className: "cls-5-Passport-p4",
    d: "M284.43,55.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM287.96,61.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-2",
    "data-name": "y",
    className: "cls-5-Passport-p4",
    d: "M296.99,55.63c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM297.6,57.26c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7-Passport-p4",
    d: "M511.44,169.02c0-3.31,2.69-6,6-6h184.02c3.31,0,6,2.69,6,6v86.68c0,3.31-2.69,6-6,6h-184.02c-3.31,0-6-2.69-6-6v-86.68Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "G",
    className: "cls-6-Passport-p4",
    d: "M550.15,205.81c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    className: "cls-6-Passport-p4",
    d: "M567.54,214.91c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM564.48,210.23c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-2",
    "data-name": "H",
    className: "cls-6-Passport-p4",
    d: "M581.12,214.91c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM578.06,210.23c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I",
    className: "cls-6-Passport-p4",
    d: "M590.56,201.33c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM594.09,209.55c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "cls-6-Passport-p4",
    d: "M612.96,207.51c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "cls-6-Passport-p4",
    d: "M629.12,215.86c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM625.87,216.07c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "cls-6-Passport-p4",
    d: "M642.98,208.8c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-3",
    "data-name": "H",
    className: "cls-6-Passport-p4",
    d: "M659.82,214.91c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM656.76,210.23c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-6-Passport-p4",
    d: "M679.98,205.81c0,5.3-5.7,5.84-7.54,9.57h7.81v2.78h-11.81c-.41-6.86,6.72-6.79,8.15-12.22.07-1.49-.81-2.1-2.24-2.17-1.56,0-2.17.95-2.38,2.31l-3.33-.2c.34-3.06,2.17-4.75,5.7-4.75s5.64,1.49,5.64,4.69"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "passport-disable-rect",
    d: "M438.74,7.65c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.27c-3.31,0-6-2.69-6-6V7.65Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-5-Passport-p4",
    d: "M526.35,50.49c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-2",
    "data-name": "F",
    className: "cls-5-Passport-p4",
    d: "M535.99,43.63c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM535.45,55.44c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-3",
    "data-name": "y",
    className: "cls-5-Passport-p4",
    d: "M547.54,43.63c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM548.15,45.26c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p-3",
    "data-name": "p",
    className: "cls-5-Passport-p4",
    d: "M564.92,54.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM558.6,53.2c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-4",
    "data-name": "v",
    className: "cls-5-Passport-p4",
    d: "M572.93,53.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-7",
    "data-name": "x",
    className: "cls-5-Passport-p4",
    d: "M582.51,43.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM586.04,49.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "u-4",
    "data-name": "u",
    className: "cls-5-Passport-p4",
    d: "M602.88,43.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM602.81,55.44c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-2",
    "data-name": "A",
    className: "cls-5-Passport-p4",
    d: "M616.52,40.91c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "D-3",
    "data-name": "D",
    className: "cls-5-Passport-p4",
    d: "M637.51,45.33c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p-4",
    "data-name": "p",
    className: "cls-5-Passport-p4",
    d: "M653.12,54.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM646.81,53.2c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-5",
    "data-name": "v",
    className: "cls-5-Passport-p4",
    d: "M661.13,53.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-8",
    "data-name": "x",
    className: "cls-5-Passport-p4",
    d: "M670.71,43.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM674.24,49.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-2",
    "data-name": "w",
    className: "cls-5-Passport-p4",
    d: "M685.24,45.73c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n-2",
    "data-name": "n",
    className: "cls-5-Passport-p4",
    d: "M687.21,41.12v-2.04h2.17v2.04h-2.17ZM687.21,56.8v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p-5",
    "data-name": "p",
    className: "cls-5-Passport-p4",
    d: "M700.52,54.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM694.2,53.2c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s-6",
    "data-name": "s",
    className: "cls-5-Passport-p4",
    d: "M706.15,56.8v-17.72h2.17v17.72h-2.17"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-Passport-p4",
    d: "M609.87,101.82l-.3,44.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-Passport-p4",
    d: "M610.37,101.83h-1v-.5h1v.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-Passport-p4",
    d: "M609.46,160.9l-4.53-14.3,9.27.07-4.74,14.23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-Passport-p4",
    d: "M344.75,50.34h76.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-Passport-p4",
    d: "M344.76,50.84h-.5v-1h.5v1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-Passport-p4",
    d: "M436.11,50.34l-14.25,4.64v-9.28l14.25,4.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportPhase4);
export default __webpack_public_path__ + "static/media/Passport_Phase_4.3dbd149dfb443d597c1e6f8f8a293d6f.svg";
export { ForwardRef as ReactComponent };